module.exports = __webpack_public_path__ + "static/img/option.8aa7314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wolves/option.png
// module id = QZ+P
// module chunks = 1